import { useParams } from "react-router-dom";

export const useNewsId = (): string => {
    const { newsId } = useParams<{ newsId: string }>();

    return newsId ?? "";
};

export const useCatalogId = (): string => {
    const { catalogId } = useParams<{ catalogId: string }>();

    return catalogId ?? "";
};

export const useShowroomId = (): string => {
    const { showroomId } = useParams<{ showroomId: string }>();

    return showroomId ?? "";
};

export const useCollectionId = (): string => {
    const { collectionId } = useParams<{ collectionId: string }>();

    return collectionId ?? "";
};

export const useCategoryId = (): string => {
    const { categoryId } = useParams<{ categoryId: string }>();

    return categoryId ?? "";
};

export const useProductId = (): string => {
    const { productId } = useParams<{ productId: string }>();

    return productId ?? "";
};

export const usePageId = (): string => {
    const { pageId } = useParams<{ pageId: string }>();

    return pageId ?? "";
};

export const useTemplateId = (): string => {
    const { templateId } = useParams<{ templateId: string }>();

    return templateId ?? "";
};

export const useProjectId = (): string => {
    const { projectId } = useParams<{ projectId: string }>();

    return projectId ?? "";
};

export const useWorkOfferId = (): string => {
    const { workOfferId } = useParams<{ workOfferId: string }>();

    return workOfferId ?? "";
};

export const useContactId = (): string => {
    const { contactId } = useParams<{ contactId: string }>();

    return contactId ?? "";
};

export const useSpecialOfferId = (): string => {
    const { specialOfferId } = useParams<{ specialOfferId: string }>();

    return specialOfferId ?? "";
};

export const useMaterialId = (): string => {
    const { materialId } = useParams<{ materialId: string }>();

    return materialId ?? "";
};

export const useMaterialCategoryId = (): string => {
    const { materialCategoryId } = useParams<{ materialCategoryId: string }>();

    return materialCategoryId ?? "";
};

export const useMaterialSubcategoryId = (): string => {
    const { materialSubcategoryId } = useParams<{ materialSubcategoryId: string }>();

    return materialSubcategoryId ?? "";
};

export const useDocumentId = (): string => {
    const { documentId } = useParams<{ documentId: string }>();

    return documentId ?? "";
};

export const useCmNewsId = (): string => {
    const { cmNewsId } = useParams<{ cmNewsId: string }>();

    return cmNewsId ?? "";
};

export const usePartnerId = (): string => {
    const { partnerId } = useParams<{ partnerId: string }>();

    return partnerId ?? "";
};

export const usePopupId = (): string => {
    const { popupId } = useParams<{ popupId: string }>();

    return popupId ?? "";
};
